import { company } from './company'

export const services = [
  {
    title: 'Döviz Alım Satım',
    text: 'Güçlü öz sermaye yapımızla yüklü işlemlere cevap veriyor; döviz alım-satımında şeffaf ve rekabetçi kur avantajı sunuyoruz.',
  },
  {
    title: 'Uzman Ekip',
    text: 'Finans sektöründeki gelişmeleri yakından takip eden ekibimizle Ünye’de güvenilir ve hızlı hizmet veriyoruz.',
  },
  {
    title: 'Hızlı Çözüm',
    text: 'Müşteri taleplerine dürüstlük ve kalite anlayışıyla yanıt veriyor; işlemlerinizi vakit kaybetmeden tamamlıyoruz.',
  },
  {
    title: 'Kolay İşlem',
    text: 'Özel kur opsiyonları ve banka hesapları üzerinden işlem imkânı ile fiyat ve zaman avantajı sağlıyoruz.',
  },
] as const

export const aboutParagraphs = [
  `${company.legalName}, kuruluşundan bugüne Ünye ve bölgede döviz işlemlerinde güvenin adresi olmaya devam ediyor. Güçlü sermaye yapısı ile yüksek ölçekli işlemlere cevap veriyor; müşterilerimize şeffaf fiyatlandırma ve özel kur avantajları sunuyoruz.`,
  company.about,
  'Yıllardır bize güvenerek birlikte büyüdüğümüz müşterilerimiz gibi siz de doğru kurdan işlem yapmak istiyorsanız bizi arayın veya şubemizi ziyaret edin.',
] as const

export const legalWarning = [
  'Bu sitede yer alan fiyatlandırmalar, yatırım bilgi, yorum ve tavsiyeleri yatırım danışmanlığı kapsamında değildir. Yatırım danışmanlığı hizmeti; aracı kurumlar, portföy yönetim şirketleri, mevduat kabul etmeyen bankalar ile müşteri arasında imzalanacak yatırım danışmanlığı sözleşmesi çerçevesinde sunulmaktadır.',
  `${company.legalName} resmi internet sitesi üzerinde sunulan anlık kur bilgileri yalnızca bilgilendirme amaçlı olup hiçbir yatırım önerisi teşkil etmemektedir ve yatırım danışmanlığı kapsamında değildir.`,
  'Kurlar piyasa koşullarına göre anlık değişebilir. İşlem anındaki geçerli kur, gişe / yetkili personel tarafından teyit edilir. Site içeriği bağlayıcı teklif niteliği taşımaz.',
] as const

export const safetyTips = [
  'Sayarak alınız ve sayarak veriniz. Yanlışlığı anında bildiriniz.',
  'Paranızı gişeden alırken veya verirken başka şahısların araya girmesine izin vermeyiniz.',
  'Paranızı cebinize veya çantanıza yerleştirirken güvenli şekilde kamüfle ediniz; dikkat çekecek şekilde görünmesine izin vermeyiniz.',
  'Paranıza gişe görevlisi ve kendinizden başka tanımadığınız üçüncü şahısların dokunmasına ve saymasına izin vermeyiniz.',
  'Döviz bürosu dışında “fazla / eksik para vermişim” diyerek yaklaşan tanımadığınız kişilere itibar etmeyiniz. Sorun varsa firmaya gelerek yetkili ile irtibat kurunuz.',
  'Sokakta kavga veya kalabalık gruplaşmalardan uzak durunuz; bu tür durumlar tezgâh olabilir.',
  'Güvenilir yerlerden alışveriş yapınız.',
] as const

export const fakeMoneyNotes = [
  'Sahte olduğundan şüphelenilen para, hakikisiyle karşılaştırılarak mercek / büyüteç yardımıyla incelenmelidir.',
  'Rakam, yazı ve bazı desenlerde dokunulduğunda hissedilen rölyef (kabartma) baskı kontrol edilmelidir; sahte banknotlarda genellikle yoktur.',
  'Değişik açılardan bakıldığında renk değiştiren özel mürekkepli motifler sahte banknotlarda sabit renkli görünür.',
  'Işığa tutulduğunda görülen filigran, güvenlik şeridi ve diğer emniyet unsurları orijinal banknotlarda bulunur.',
  'Ultraviyole ışığa duyarlı lifler ve fosforlu özellikler özel kontrol cihazıyla yalnızca gerçek banknotlarda görülür.',
] as const
